export const DragItemTypes = {
    PALETTE_BOX: 'palbox',
    FLOW_BOX: 'flowbox',
};

